import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { BuildEnvironment } from "src/environments/environment";
import { IAnnouncement } from "../models/announcement.model";

@Injectable({
  providedIn: "root",
})
export class AnnouncementService {
  private baseurl: string;

  constructor(private http: HttpClient) {
    const rootURL = BuildEnvironment.GetEnvironmentUrl();
    this.baseurl = rootURL;
  }

  getAllPublished(urn: string): Observable<IAnnouncement[]> {
    console.log(this.baseurl);
    return this.http.get<IAnnouncement[]>(this.baseurl + urn);
  }

  getAll(urn: string): Observable<IAnnouncement[]> {
    return this.http.get<IAnnouncement[]>(this.baseurl + urn);
  }

  getById(id: number, urn: string): Observable<IAnnouncement[]> {
    return this.http.get<IAnnouncement[]>(this.baseurl + urn + id).pipe(
      catchError((error) => {
        console.log("---------Unexpected error occurred-------", error);
        return throwError(() => new Error(error)); // Rethrow the error so it can be handled by the subscriber
      })
    );
  }
  insertRecord(formdata: any, urn: string): Observable<IAnnouncement> {
    return this.http
      .post<IAnnouncement>(this.baseurl + urn, formdata)
      .pipe(catchError(this.handleError));
  }

  updateData(
    formdata: any,
    id: number,
    urn: string
  ): Observable<IAnnouncement> {
    return this.http
      .post<IAnnouncement>(this.baseurl + urn + id, formdata)
      .pipe(catchError(this.handleError));
  }

  archiveRecord(
    formdata: any,
    id: number,
    urn: string
  ): Observable<IAnnouncement> {
    return this.http
      .post<IAnnouncement>(this.baseurl + urn + id, formdata)
      .pipe(catchError(this.handleError));
  }

  deleteRecord(id: number, urn: string): Observable<IAnnouncement> {
    return this.http
      .delete<IAnnouncement>(this.baseurl + urn + id, {
        headers: {},
        params: { announcementid: id },
      })
      .pipe(catchError(this.handleError));
  }

  private handleError(err: HttpErrorResponse) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage = "";
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
